
import { Component, Vue } from 'vue-property-decorator'
import NotificationEditor from '@/components/notification/NotificationEditor.vue'

@Component({
  name: 'Redemptions',
  components: { NotificationEditor }
})
class Notification extends Vue {}

export default Notification
